'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.orders = orders;
function orders() {
  return {
    type: 'ORDERS',
    promise: function promise(_ref) {
      var api = _ref.api;
      return api('/orders').get();
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./shared/actions/orders.js
// module id = 2245
// module chunks = 0